import {
  gql,
  MutationFunction,
  MutationResult,
  useMutation
} from '@apollo/client'
import { Basket_Response } from 'shared/presenters/graphqlTypes'
import useBasket from './useBasket'

interface UseRemovePriceModifierResult {
  removePriceModifier: MutationFunction
  removePriceModifierLoading: MutationResult['loading']
}

export type UseRemovePriceModifier = () => UseRemovePriceModifierResult

/**
 * It calls a mutation to remove a price modifier.
 *
 * Use this function in combination with the PriceModifierBar component to insert a code and redeem a credit voucher, activity voucher or class pass.
 */
const useRemovePriceModifier: UseRemovePriceModifier = () => {
  const { refetchBasket } = useBasket()

  const [removePriceModifier, { loading: removePriceModifierLoading }] =
    useMutation<{
      Consumer_Baskets_RemovePriceModifier: Basket_Response
    }>(REMOVE_PRICE_MODIFIER, {
      onCompleted({ Consumer_Baskets_RemovePriceModifier }) {
        refetchBasket({
          basketId: Consumer_Baskets_RemovePriceModifier.basket_id
        })
      }
    })

  return { removePriceModifier, removePriceModifierLoading }
}

const REMOVE_PRICE_MODIFIER = gql`
  mutation WidgetUseRemovePriceModifier(
    $basketId: ID!
    $code: String!
    $line_item_id: ID
  ) {
    Consumer_Baskets_RemovePriceModifier(
      basket_id: $basketId
      code: $code
      line_item_id: $line_item_id
    ) {
      basket_id
      price_after_adjustments_pence
    }
  }
`

export default useRemovePriceModifier
